module.exports = __webpack_public_path__ + "static/media/about-img.899f6ec8.png";